import { render, staticRenderFns } from "./Results2.vue?vue&type=template&id=38ce8fcc&"
import script from "./Results2.vue?vue&type=script&lang=js&"
export * from "./Results2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports